import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

export const qaCurriculumData = {
  curriculum: [
    {
      title: 'Introductory Session',
      staticImage: (
        <StaticImage
          imgStyle={{ objectFit: 'contain' }}
          loading="lazy"
          src="../images/v5/CurriculumIcons/One.png"
          placeholder="blurred"
          width={300}
          alt="Mobile Navbar"
        />
      ),
      image: null,
      duration: 'Free Trial',
      tag: 'FREE_TRIAL',
      data: (
        <>
          <ul>
            <li>
              Learn Web-based Automation for sites like Redbus and Amazon —
              fetch pages, extract element data, automate tasks.
            </li>
            <li>
              Understand how LeetCode/HackerRank test code submissions — test
              data identification, manual & automated testing.
            </li>
            <li>
              Get hands-on with your first automated test — fetch a page, find
              elements, and validate results
            </li>
            <li>
              Understand the difference between manual testing, automated
              testing, and web-based automation
            </li>
          </ul>
        </>
      ),
      skills: ['Manual testing', 'Automated testing', 'Web-based automation'],
      projects: null,
      anchor: 'introductory-session',
    },
    {
      title: 'Programming Essentials',
      staticImage: (
        <StaticImage
          imgStyle={{ objectFit: 'contain' }}
          loading="lazy"
          src="../images/v5/CurriculumIcons/Two.png"
          placeholder="blurred"
          width={300}
          alt="Mobile Navbar"
        />
      ),
      image: null,
      duration: '8 weeks',
      tag: null,
      data: (
        <>
          <ul>
            <li>
              Strengthen foundational Java programming through hands-on
              activities and curated problem statements
            </li>
            <li>
              Master Object-Oriented Programming — classes, inheritance,
              polymorphism, encapsulation, and abstraction applied to real
              testing scenarios
            </li>
            <li>
              Learn Collections framework — ArrayList, HashMap, HashSet —
              essential for test data management and result aggregation
            </li>
            <li>
              Exception handling patterns for robust test code that doesn't
              break silently
            </li>
            <li>
              Debugging techniques to identify and fix issues in test automation
              code efficiently
            </li>
          </ul>
        </>
      ),
      skills: [
        'Java',
        'OOPS',
        'Collections',
        'Exception Handling',
        'Debugging',
        'JUnit',
      ],
      projects: null,
      anchor: 'programming-essentials',
    },
    {
      title: 'Developer Essentials',
      staticImage: (
        <StaticImage
          imgStyle={{ objectFit: 'contain' }}
          loading="lazy"
          src="../images/v5/CurriculumIcons/Three.png"
          placeholder="blurred"
          width={300}
          alt="Mobile Navbar"
        />
      ),
      image: null,
      duration: '2 weeks',
      tag: null,
      data: (
        <>
          <ul>
            <li>
              Get introduced to key SDET skills through mini-projects and
              hands-on activities
            </li>
            <li>
              Master Linux command line for server-side testing, log analysis,
              and CI environment debugging
            </li>
            <li>
              SQL for database validation — write queries to verify data
              integrity across microservices
            </li>
            <li>
              Git workflows for managing test code — branching, merging,
              resolving conflicts in automation repos
            </li>
            <li>
              CI/CD with Jenkins — configure automated test pipelines that run
              on every commit
            </li>
          </ul>
        </>
      ),
      skills: [
        'Agile',
        'SQL',
        'Linux',
        'Git',
        'HTML Basics',
        'Gradle',
        'CI/CD',
        'Jenkins',
        'Bugzilla',
        'TestRail',
      ],
      projects: null,
      anchor: 'developer-essentials',
    },
    {
      title: 'Testing Essentials',
      staticImage: (
        <StaticImage
          imgStyle={{ objectFit: 'contain' }}
          loading="lazy"
          src="../images/v5/CurriculumIcons/Four.png"
          placeholder="blurred"
          width={300}
          alt="Mobile Navbar"
        />
      ),
      image: null,
      duration: '2 weeks',
      tag: null,
      data: (
        <>
          <ul>
            <li>
              Master testing fundamentals through carefully designed workshops
              and activities
            </li>
            <li>
              Design comprehensive test strategies that cover functional,
              non-functional, and edge-case scenarios
            </li>
            <li>
              Generate effective test data that covers boundary values,
              equivalence classes, and real-world patterns
            </li>
            <li>
              Understand the complete Defect Life Cycle — from identification
              through resolution and verification
            </li>
            <li>
              Learn estimation techniques for accurate test effort planning in
              Agile sprints
            </li>
          </ul>
        </>
      ),
      skills: [
        'Test Strategy',
        'Test Data',
        'Defect Lifecycle',
        'Estimation'
      ],
      projects: null,
      anchor: 'testing-essentials',
    },
    {
      title:
        'Web Based Automation',
      staticImage: (
        <StaticImage
          imgStyle={{ objectFit: 'contain' }}
          loading="lazy"
          src="../images/v5/CurriculumIcons/Five.png"
          placeholder="blurred"
          width={300}
          alt="Mobile Navbar"
        />
      ),
      image: null,
      duration: '16 weeks',
      tag: null,
      data: (
        <>
          <p>
            Through a carefully designed series of hands-on workshops and
            mini-projects, learn fundamental testing concepts that are essential
            to become a strong SDET.
          </p>
          <ul>
            <li>
              <span className="font-bold">QKart:</span> Create Automated Test
              Cases for a Flipkart-like web-based application. Implement
              data-driven testing with Apache POI, build a robust Page Object
              Model framework, and generate test reports with Extent Reports.
              Work with experienced mentors who review your code.
            </li>
            <li>
              <span className="font-bold">QTrip:</span> Architect a complete
              Selenium Framework using Page Object Model, TestNG, Selenium Grid
              for parallel execution, Extent Reports, and Cucumber BDD. Automate
              test cases for an AirBnB-like web-based application and deploy
              tests to run across multiple browsers simultaneously.
            </li>
          </ul>
        </>
      ),
      footer: (
        <p>
          <span className="font-bold">You'll be able to: </span>
          Build production-grade Selenium frameworks · Implement POM, BDD, and
          data-driven patterns · Run parallel tests with Grid · Generate rich
          HTML test reports · Debug test failures efficiently
        </p>
      ),
      skills: [
        'Selenium',
        'Web Driver',
        'XPath',
        'Apache POI',
        'Page Object Model',
        'Framework',
        'Grid',
        'TestNG',
        'Cucumber',
      ],
      projects: [
        {
          title: 'QKart',
          description:
            'Create Automated Test Cases for a Flipkart like web-based application with guidance from experienced mentors',
        },
        {
          title: 'QTrip',
          description:
            'Architect a Selenium Framework using concepts like Page Object Model, Test NG, Extent Reports etc. and automate test cases for an AirBnB like web-based application using this framework',
        },
      ],
      anchor: 'hands-on-sdet-real-web-apps',
    },
    {
      title: 'Data Structures and Algorithms',
      staticImage: (
        <StaticImage
          imgStyle={{ objectFit: 'contain' }}
          loading="lazy"
          src="../images/v5/CurriculumIcons/Six.png"
          placeholder="blurred"
          width={300}
          alt="Mobile Navbar"
        />
      ),
      image: null,
      duration: '8 weeks',
      tag: null,
      data: (
        <>
          <p>
            Master essential Data Structures from an interview perspective and
            understand their applications in the real world.
          </p>
          <ul>
            <li>
              Learn to solve 200+ curated problems covering the most-asked
              patterns in SDET interviews at top product companies
            </li>
            <li>
              Master the Crio problem-solving methodology — understand, plan,
              code, test — applied to every coding challenge
            </li>
            <li>
              Practice with timed mock assessments that simulate real interview
              conditions
            </li>
          </ul>
        </>
      ),
      skills: [
        'Time space complexity',
        'Arrays',
        'Linked List',
        'Stack/Queue',
        'Trees',
        'Hash',
        'Sort',
        'Search',
      ],
      projects: null,
      anchor: 'data-structures-and-algorithms',
    },
  ],
  advancedCurriculum: [
    {
      title:
       'Master SDET skills with a live distributed backend on the cloud',
      staticImage: (
        <StaticImage
          imgStyle={{ objectFit: 'contain' }}
          loading="lazy"
          src="../images/v5/CurriculumIcons/One.png"
          placeholder="blurred"
          width={300}
          alt="Mobile Navbar"
        />
      ),
      image: null,
      duration: '7 weeks',
      data: (
        <>
          <p>
            Create and execute integration tests on LIVE Flipkart-like
            distributed backend systems deployed on AWS.
          </p>
          <ul>
            <li>
              Implement API testing to test individual microservices on the
              backend
            </li>
            <li>
              Implement DB testing to test correctness of SQL tables for the
              common user journeys
            </li>
            <li>
              Write e2e integration tests for data flows involving Kafka queues,
              REST APIs and DB across microservices
            </li>
            <li>
              Benchmark API performance for microservices using JMeter
              (Performance testing)
            </li>
          </ul>
        </>
      ),
      skills: [
        'API',
        'API Testing',
        'DB Testing',
        'REST Assured',
        'Performance Testing',
        'Microservices Testing',
        'Integration Testing',
        'Kafka',
        'JMeter',
      ],
      anchor: 'master-sdet-skills-with-live-distributed-backend',
    },
    {
      title: 'Test Strategy & Design for various system architectures',
      staticImage: (
        <StaticImage
          imgStyle={{ objectFit: 'contain' }}
          loading="lazy"
          src="../images/v5/CurriculumIcons/Two.png"
          placeholder="blurred"
          width={300}
          alt="Mobile Navbar"
        />
      ),
      image: null,
      duration: '2 weeks',
      data: (
        <>
          <p>
            Learn the nuances of different system architectures and how to
            effectively test them.
          </p>
          <ul>
            <li>Big Data systems</li>
            <li>Event-driven architecture</li>
            <li>Microservices</li>
            <li>N-tier applications</li>
          </ul>
        </>
      ),
      skills: ['System Architecture', 'Test Strategy', 'Test Plan'],
      anchor: 'test-strategy-and-design-for-various-system-architectures',
    },
    {
      title:
        'Foundations of Cloud/Devops',
      staticImage: (
        <StaticImage
          imgStyle={{ objectFit: 'contain' }}
          loading="lazy"
          src="../images/v5/CurriculumIcons/Three.png"
          placeholder="blurred"
          width={300}
          alt="Mobile Navbar"
        />
      ),
      image: null,
      duration: '3 weeks',
      data: (
        <>
          <p>
            Learn important concepts required to become a competent new-age
            automation/SDET engineer. Get familiar with cloud concepts like
            virtualization, containerization, and cloud services around compute,
            storage, and networking.
          </p>
        </>
      ),
      skills: [
        'Cloud concepts',
        'Cloud services',
        'CI/CD',
        'Virtualization',
        'Docker',
        'Deployment',
        'Scripting',
        'Advanced Git',
        'Test Bed Creation',
        'Swagger',
        'Postman',
        'BDD',
        'TDD',
        'Agile',
      ],
      anchor:
        'cloud-devops-foundations-and-sdlc-best-practices-for-automation-sdet',
    },
    {
      title: 'JavaScript + Playwright + TypeScript for Modern Test Automation',
      new: true,
      duration: '12 Sessions',
      data: (
        <>
          <p>
            You already know Selenium. Now build the modern stack on top of it, and ship a production framework with CI/CD and AI-assisted testing.
          </p>
          <ul>
            <li>
              <span className="font-bold">JavaScript and TypeScript for Test Automation</span>{' '}

            </li>
            <li>
              <span className="font-bold">
                Foundations:
              </span>{' '}
             Playwright architecture vs Selenium, the role-based locator ladder, web-first assertions, auto-waiting, and Trace Viewer time-travel debugging.
            </li>
            <li>
              <span className="font-bold">
                Test Runner & Framework Architecture: 
              </span>{' '}
              @playwright/test, custom fixtures, storageState authentication and config layering.
            </li>
            <li>
              <span className="font-bold">
                Beyond the Browser: 
              </span>{' '}
              API testing with APIRequestContext, hybrid UI+API tests, network interception and mocking, visual regression, accessibility scans, and advanced browser control.
            </li>
            <li>
              <span className="font-bold">
                Production & AI: 
              </span>{' '}
              CI/CD with GitHub Actions - sharding, Docker, artifacts; Playwright MCP and the planner/generator/healer test agent.
            </li>
            <li>
              <span className="font-bold">Capstone — QTrip, Playwright Edition (project).</span>{' '}

            </li>
          </ul>
        </>
      ),
      footer: (
        <p>
          <span className="font-bold">You'll be able to: </span>Build and own a production Playwright framework in TypeScript.
        </p>
      ),
      skills: [
        'Playwright',
        'TypeScript',
        'Test Runner',
        'Fixtures',
        'API Testing',
        'Network Mocking',
        'CI/CD',
        'GitHub Actions',
        'Sharding',
        'Trace Viewer',
        'Visual Regression',
        'Accessibility',
        'Playwright MCP'
      ],
      anchor: 'playwright-for-modern-web-automation',
    },
    {
      title: 'AI Developer Foundations',
      new: true,
      duration: '9 Sessions',
      data: (
        <>
          <p>
            Go from zero AI background to confidently building with LLMs — the
            foundation every modern QA engineer needs in 2026.
          </p>
          <ul>
            <li>How LLMs Work (And Why It Matters)</li>
            <li>Navigating the AI Model Landscape</li>
            <li>Prompt Engineering That Actually Works</li>
            <li>Building with the OpenAI API</li>
            <li>Fine-Tuning — When & How to Train Your Own Model</li>
            <li>RAG Pipelines — Make AI Know Your Data</li>
            <li>Building AI Agents That Take Action</li>
            <li>Full-Stack AI Apps with Bolt.new</li>
            <li>AI-Powered Development with Cursor</li>
          </ul>
        </>
      ),
      skills: [
        'LLMs',
        'OpenAI API',
        'LangChain',
        'Cursor',
        'Bolt.new',
        'RAG',
        'Fine-Tuning',
      ],
      anchor: 'ai-developer-foundations',
    },
    {
      title: 'Build & Ship Production AI Systems',
      new: true,
      duration: '8 Sessions · 16 Hours',
      data: (
        <>
          <p>
            Take your AI skills production-grade — build, evaluate, and ship a
            real AI product as your capstone.
          </p>
          <ul>
            <li>Building LLM-Powered Applications</li>
            <li>Vibe Coding with Claude Code & Cursor</li>
            <li>From Single Agents to Multi-Agent Systems</li>
            <li>AI Agents That Integrate Everything (MCP)</li>
            <li>RAG Systems — Search Anything with AI</li>
            <li>How to Know If Your AI Actually Works (Evals)</li>
            <li>Production AI — Scaling, Cost & Monitoring</li>
            <li>Capstone — Build & Ship a Real AI Product</li>
          </ul>
        </>
      ),
      skills: [
        'LangGraph',
        'Claude Code',
        'MCP',
        'FAISS',
        'Pinecone',
        'RAGAS',
        'Langfuse',
      ],
      anchor: 'build-ship-production-ai-systems',
    }
  ],
};
